import { render } from "./CreateMessage.vue.js?vue&type=template&id=31399396!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateMessage.vue?vue&type=template&id=31399396"
import script from "./CreateMessage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateMessage.vue?vue&type=script&lang=js"
export * from "./CreateMessage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/CreateMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31399396"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31399396', __exports__)) {
    api.reload('31399396', __exports__)
  }
  
  module.hot.accept("./CreateMessage.vue.js?vue&type=template&id=31399396!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateMessage.vue?vue&type=template&id=31399396", () => {
    api.rerender('31399396', render)
  })

}


export default __exports__